export function StatCard({ label, value, sub, tone = "default", testId }) {
  const tones = {
    default: "text-foreground",
    primary: "text-blue-800 dark:text-blue-400",
    success: "text-emerald-600 dark:text-emerald-400",
    error: "text-red-600 dark:text-red-400",
    warning: "text-amber-500 dark:text-amber-400",
  };
  return (
    <div
      className="border border-border rounded-md bg-card p-5 h-full transition-transform duration-150 hover:-translate-y-0.5"
      data-testid={testId}
    >
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium">{label}</div>
      <div className={`mt-2 text-3xl font-display font-extrabold tracking-tight ${tones[tone]}`} data-testid={`${testId}-value`}>
        {value ?? "—"}
      </div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}
